module.exports = __webpack_public_path__ + "img/journal.6764f359.jpg";